<template>
    <div>
        <div class="flex flex-col break-normal text-gray-800">
            <div class="flex justify-between items-center text-gray-500 font-normal pl-1 text-sm">
                <span>
                    <span class="text-indigo-600">{{ signature.signatory_name }}</span> on <span class="text-gray-800">{{ signature.signed_on | datetime }}</span>
                </span>

                <div class="flex justify-between items-center space-x-2">
                    <badge :class="setBadgeClass(signature)" :title="setTitle(signature)">
                        {{ signature.signatory_group  | titlecase }}
                    </badge>

                    <button @click.prevent="showDeleteConfirmationModal(signature)"
                            v-if="userCan('manage-inspections')" title="Delete Signature">
                        <icon-trash class="w-4 h-4 text-gray-400 hover:text-brand transition duration-300"></icon-trash>
                    </button>
                </div>
            </div>

            <div class="flex flex-col border border-gray-200 rounded p-1 w-full text-gray-600 mt-1 text-xs">
                <div class="w-full" v-if="signature.type === 'media' && signature.signature_file_url">
                    <img style="max-height: 100px;" :src="signature.signature_file_url" alt="Inspection Signature">
                </div>

                <template v-if="signature.type === 'digital'">
                    <div class="">
                        {{ signature.signature_declaration }}
                    </div>
                    <div class="mt-2" v-if="signature.signatory_mobile">
                        <b>Verified</b> with Sms based one time pin sent to {{ signature.signatory_mobile }}.
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SignaturesListMixin from "../../mixins/inspection-signatures-list-mixin";

export default {
    name: "InspectionSignature",

    mixins: [SignaturesListMixin],

    props: {
        signature: {
            type: Object,
            required: true
        },
    },

    methods: {
        showDeleteConfirmationModal (signature) {
            this.$emit("show-delete-modal", signature);
        },

        closeModal () {
            this.$emit("close");
        },

        labelBackgroundAndText (signature) {
            switch (signature.signatory_group.toLowerCase()) {
                case "tenant":
                    return "bg-green-200 text-green-600";
                case "landlord":
                    return "bg-orange-200 text-orange-600";
                case "agent":
                    return "bg-indigo-200 text-indigo-600";
                default:
                    return "bg-yellow-100 text-yellow-600";
            }
        },
    },
};
</script>